import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { LEARN_LESSON_COUNT } from '@/constants/learnCurriculum';
import { PrimaryCta, Section, useLanding } from './LandingKit';
import { fluid } from './landingTokens';

function LandingLearn() {
  const { c, width, isXS, isCompact } = useLanding();
  return (
    <Section label="Gab AI Learn" background={c.panel} contentStyle={{ paddingVertical: fluid(width, 32, 48) }}>
      <View style={{ flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'stretch' : 'center', justifyContent: 'space-between', gap: 24 }}>
        <View style={{ flex: 1, minWidth: 0, maxWidth: 620 }}>
          <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: 28, lineHeight: 36, letterSpacing: -0.7 }}>Start small. Learn at your pace.</Text>
          <Text tag="p" style={{ color: c.inkSoft, fontSize: 15, lineHeight: 24, marginTop: 12 }}>{LEARN_LESSON_COUNT} free video lessons, from your first prompt to your first Work project. No experience needed.</Text>
        </View>
        <View><PrimaryCta label="Start learning free" href="/docs#learn" restrained full={isXS} /></View>
      </View>
    </Section>
  );
}

export default React.memo(LandingLearn);
